import axios from "axios";
import { BIDS_URL } from "../utils";

export const fetchBids = () => {
  return axios.get(BIDS_URL);
};
